var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "from",
    staticStyle: {
      "padding": "0 10%"
    },
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目名称",
      "prop": "project_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择项目",
      "filterable": ""
    },
    model: {
      value: (_vm.from.project_id),
      callback: function($$v) {
        _vm.$set(_vm.from, "project_id", $$v)
      },
      expression: "from.project_id"
    }
  }, _vm._l((_vm.$parent.$parent.projectList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.project_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宿舍名称",
      "prop": "dormitory_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入宿舍名称"
    },
    model: {
      value: (_vm.from.dormitory_name),
      callback: function($$v) {
        _vm.$set(_vm.from, "dormitory_name", $$v)
      },
      expression: "from.dormitory_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宿舍地址",
      "prop": "dormitory_address"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入宿舍地址"
    },
    model: {
      value: (_vm.from.dormitory_address),
      callback: function($$v) {
        _vm.$set(_vm.from, "dormitory_address", $$v)
      },
      expression: "from.dormitory_address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "负责人姓名",
      "prop": "staff_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择负责人",
      "filterable": ""
    },
    model: {
      value: (_vm.from.staff_id),
      callback: function($$v) {
        _vm.$set(_vm.from, "staff_id", $$v)
      },
      expression: "from.staff_id"
    }
  }, _vm._l((_vm.$parent.$parent.staffList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.staff_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "负责人电话",
      "prop": "staff_phone"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入负责人电话"
    },
    model: {
      value: (_vm.from.staff_phone),
      callback: function($$v) {
        _vm.$set(_vm.from, "staff_phone", $$v)
      },
      expression: "from.staff_phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "30%",
      "background-color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-781f47d4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xzgl/SsfjGl/SsfjGl_add.vue
// module id = null
// module chunks = 